import {
    BaseBoxShapeUtil,
    HTMLContainer,
    RecordProps,
    T,
    TLBaseShape,
    stopEventPropagation,
    TLResizeHandle,
} from 'tldraw'
import {TaskStatusType} from "../types/taskFlow.types";
import CircularProgress from "@mui/material/CircularProgress";
import {TaskLoading} from "../icons";
import {TextareaAutosize} from "@mui/material";


type IMyEditableShape = TLBaseShape<
    'describe-shape',
    {
        text: string,
        status: string,
        h: number,
        w: number,
        loading: boolean
        taskId: number,
        imageData?: string[],
    }
>

export class DescribeShapeUtil extends BaseBoxShapeUtil<IMyEditableShape> {
    static override type = 'describe-shape' as const
    static override props: RecordProps<IMyEditableShape> = {
        text: T.string,
        status: T.string,
        w: T.number,
        h: T.number,
        loading: T.boolean,
        taskId: T.number,
        imageData: T.any
    }


    getDefaultProps(): IMyEditableShape['props'] {
        return {
            text: '对【蛇元素】和【新中式】进行发散联想',
            status: '待确认',
            w: 260,
            h: 400,
            loading: true,
            taskId: 0,
            imageData: undefined
        }
    }

    // 禁用调整大小功能
    override canResize = (_shape: IMyEditableShape) => {
        return false
    }

    // 隐藏调整大小的控制点
    override hideResizeHandles = (_shape: IMyEditableShape): boolean => {
        return true
    }

    // [2]
    component(shape: IMyEditableShape) {
        // [a]
        const isEditing = this.editor.getEditingShapeId() === shape.id

        return (
            <HTMLContainer
                id={shape.id}
                // [b]
                onPointerDown={isEditing ? stopEventPropagation : undefined}
                style={{
                    pointerEvents: "all",
                }}
            >
                <div style={{
                    width: '100%',
                    height: '100%',
                    padding: 0,
                    borderRadius: 10
                }}>

                    <div style={{
                       // border: '1px solid #DDDDDD',
                       // borderRadius: 6,
                        padding: 10,
                        color: '#444444',
                        whiteSpace: 'pre-wrap',
                        lineHeight: "25px",
                        fontFamily: 'monospace',
                    }}>
                        {shape.props.text}
                    </div>

                </div>
            </HTMLContainer>
        )
    }

    indicator(shape: IMyEditableShape) {
        // 返回固定大小的indicator
        return <rect width={shape.props.w} height={shape.props.h} />
    }
}